import React, { Component } from "react"
import { Motion, spring, presets } from "react-motion"
import styled from "styled-components"
import theme from "../Theme"

const SidebarContainer = styled.div`
  background: linear-gradient(
    180deg,
    ${props => props.theme.backgroundGradientDark},
    ${props => props.theme.backgroundGradientLight}
  );
  width: 12rem;
  overflow: auto;
  flex-shrink: 0;
`

SidebarContainer.defaultProps = { theme }

type State = {
  offset: string
}

type Props = {
  children: React$Element<any>
}

class Sidebar extends Component<Props, State> {
  render() {
    return (
      <Motion
        defaultStyle={{ offset: -12 }}
        style={{ offset: spring(0, presets.noWobble) }}
      >
        {interpolatedStyle => (
          <SidebarContainer
            key="sidebar"
            style={{
              transform: `translate(${interpolatedStyle.offset}rem, 0)`
            }}
          >
            {this.props.children}
          </SidebarContainer>
        )}
      </Motion>
    )
  }
}

export default Sidebar



// WEBPACK FOOTER //
// ./src/UI/Sidebar/Sidebar.js